// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"styles_formContainer__3iF8H","input":"styles_input__1XfY-","aliyahDate":"styles_aliyahDate__3hk47","spouse":"styles_spouse__1rJRG","note":"styles_note__2N4f6"};